<template>
  <pos-layout>
    <template #navbar>
      <span>&nbsp;</span>
    </template>

    <div class="h-100 orders d-print-none">
      <!-- Print panel For mobile -->
      <div class="print d-md-none">
        <b-row class="h-100 no-gutters">
          <b-col
            cols="3"
            class="h-100 d-md-none"
          >
            <b-button
              v-if="currentOrder && currentOrder.table"
              :to="{ name: 'Tables', params: { id: currentOrder.table }}"
              variant="link"
              class="w-100 bg-pink"
            >
              <svg class="icon icon-icon-table">
                <use xlink:href="#icon-icon-table" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.print-to-tables-mob") }}
              </span>
            </b-button>
          </b-col>

          <b-col
            cols="3"
            class="h-100"
          >
            <b-button
              :class="{'btn-disabled': itemsAtCurrentOrderLength === 0}"
              variant="link"
              class="w-100"
              @click="printCheck()"
              @mousedown="start"
              @mouseleave="stop"
              @mouseup="stop"
              @touchstart="start"
              @touchend="stop"
              @touchcancel="stop"
            >
              <svg class="icon icon-icon-print-1">
                <use xlink:href="#icon-icon-print-1" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.print-check") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            v-if="!isRetailMode"
            cols="3"
            class="h-100"
          >
            <b-button
              variant="link"
              class="w-100 btn-disabled"
            >
              <svg class="icon icon-icon-print-2">
                <use xlink:href="#icon-icon-print-2" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.kitchen-print") }}
              </span>
            </b-button>
          </b-col>
          <b-col
            cols="3"
            class="h-100 d-none d-md-block"
          >
            <b-button
              variant="link"
              class="w-100 btn-disabled"
            >
              <svg class="icon icon-icon-print-3">
                <use xlink:href="#icon-icon-print-3" />
              </svg>

              {{ $t("amountandpaymentmethod.open-drawer") }}
            </b-button>
          </b-col>
          <b-col
            cols="3"
            class="h-100 d-none d-md-block"
          >
            <b-button
              variant="link"
              class="w-100"
            >
              <svg class="icon icon-icon-print-4">
                <use xlink:href="#icon-icon-print-4" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.credit-card") }}
              </span>
            </b-button>
          </b-col>

          <b-col
            v-if="!sidebarMob"
            cols="3"
            class="h-100 d-md-none"
          >
            <b-button
              variant="link"
              class="w-100 bg-primary"
              @click="sidebarMob = !sidebarMob"
            >
              <svg class="icon icon-icon-mob-add">
                <use xlink:href="#icon-icon-mob-add" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.payment-options") }}
              </span>
            </b-button>
          </b-col>

          <b-col
            v-if="sidebarMob"
            cols="3"
            class="h-100 d-md-none"
          >
            <b-button
              variant="link"
              class="w-100 bg-info"
              @click="sidebarMob = !sidebarMob"
            >
              <svg class="icon icon-icon-mob-view">
                <use xlink:href="#icon-icon-mob-view" />
              </svg>

              <span>
                {{ $t("amountandpaymentmethod.print-view-order-mob") }}
              </span>
            </b-button>
          </b-col>
        </b-row>
      </div>


      <b-row class="h-100 h-sm-100 no-gutters">
        <b-col
          :class="{hide: sidebarMob}"
          col
          cols="12"
          md="5"
          lg="4"
          class="h-100 orders-sidebar-mob"
        >
          <CheckoutOrderSidebar
            :is-kiosk-mode="isKioskMode"
            :display-order-with-table="displayOrderWithTable"
            :order-dining-option="orderDiningOption"
            :allow-cash-discount="allowCashDiscount"
            :current-order="currentOrder"
            :items-at-current-order="itemsAtCurrentOrder"
            :currency="currency"
            :is-display-payment-details="isDisplayPaymentDetails"
            :current-order-sum="currentOrderSum"
            :current-order-grand-total-sum="currentOrderGrandTotalSum"
            :get-item-display-name="getItemDisplayName"
            :get-item-grand-total="getItemGrandTotal"
            :get-item-price-display="getItemPriceDisplay"
            :get-modifiers-by-item-position="getModifiersByItemPosition"
            @cancel-order="cancelOrder"
            @show-select-customer-modal="showSelectCustomerModal"
            @toggle-cash-discount="toggleCashDiscount"
            @display-payment-details="displayPaymentDetails"
            @change-quantity="changeQuantity"
            @remove-item="removeItemFromOrder"
          />
        </b-col>

        <b-col
          col
          cols="12"
          md="7"
          lg="8"
          class="h-100 orders-col checkout-col"
        >
          <div class="h-100 checkout-container">
            <div
              class="checkout-wrapper d-md-flex"
              :class="isKioskMode ? 'justify-content-center' : 'justify-content-between'"
            >
              <div
                :class="{ 'checkout-kiosk': isKioskMode }"
                class="checkout h-100"
              >
                <div class="checkout-head text-center" />

                <div
                  class="checkout-body"
                >
                  <h5
                    v-if="isKioskMode"
                    class="checkout-title"
                  >
                    Amount to be Paid
                  </h5>

                  <CheckoutTenderPad
                    :is-kiosk-mode="isKioskMode"
                    :has-dual-pricing="hasDualPricing"
                    :currency="currency"
                    :cash-price="cashPrice"
                    :credit-card-price="creditCardPrice"
                    :amount-tendered="amountTendered"
                    :amount-tendered-string="amountTenderedString"
                    :is-amount-pre-filled="isAmountPreFilled"
                    :payment-types="paymentTypes"
                    :is-payment-processing="isPaymentProcessing"
                    :refund-order-id="refundOrderId"
                    :quick-cash="quickCash"
                    :has-table="currentOrder.table"
                    @type-num="typeNum"
                    @input-started="isAmountPreFilled = false"
                    @type-custom="typeCustom"
                    @go-to-table-orders="goToTableOrders"
                    @pay="!isPaymentProcessing ? pay($event) : null"
                  />

                  <div
                    v-if="!isKioskMode"
                    class="print d-none d-md-block"
                  >
                    <b-row class="h-100 no-gutters">
                      <b-col
                        :cols="isRetailMode ? 6 : 4"
                        class="h-100"
                      >
                        <b-button
                          :class="{'btn-disabled': itemsAtCurrentOrder.length === 0 }"
                          variant="link"
                          class="w-100"
                          @click="printCheck()"
                        >
                          <svg class="icon icon-icon-print-1">
                            <use xlink:href="#icon-icon-print-1" />
                          </svg>

                          <span>
                            {{ $t("amountandpaymentmethod.print-check") }}
                          </span>
                        </b-button>
                      </b-col>
                      <b-col
                        v-if="!isRetailMode"
                        cols="4"
                        class="h-100"
                      >
                        <div
                          v-if="isKitchenPrintProcessing"
                          class="text-center spiner-overbutton"
                        >
                          <b-spinner
                            variant="primary"
                            label="Text Centered"
                          />
                        </div>
                        <b-button
                          :class="{'btn-disabled': !kitchenUpdatesAvailable}"
                          variant="link"
                          class="w-100"
                          @click="handleKitchenPrint()"
                        >
                          <svg class="icon icon-icon-print-2">
                            <use xlink:href="#icon-icon-print-2" />
                          </svg>

                          <span>
                            {{ $t("amountandpaymentmethod.kitchen-print") }}
                          </span>
                        </b-button>
                      </b-col>
                      <b-col
                        :cols="isRetailMode ? 6 : 4"
                        class="h-100"
                      >
                        <b-button
                          variant="link"
                          class="w-100"
                          @click="openDrawer()"
                        >
                          <svg class="icon icon-icon-print-5">
                            <use xlink:href="#icon-icon-print-5" />
                          </svg>
                          <span>
                            {{ $t("amountandpaymentmethod.open-drawer") }}
                          </span>
                        </b-button>
                      </b-col>
                    </b-row>
                  </div>
                </div>

                <div class="checkout-bottom px-1 px-lg-4">
                  <div class="d-lg-flex align-items-center justify-content-between h-100">
                    <div class="orders-user">
                      <span class="icon">
                        <img
                          src="@/assets/images/customer-photo.png"
                          alt=""
                        >
                      </span>

                      <span>
                        Sauro
                      </span>
                    </div>

                    <div class="checkout-bottom-settings ml-auto">
                      <div class="d-flex align-items-center">
                        <a
                          href="#"
                          class="btn btn-warning"
                        >
                          {{ $t("amountandpaymentmethod.on-account") }}
                        </a>

                        <a
                          href="#"
                          class="btn btn-warning"
                        >
                          {{ $t("amountandpaymentmethod.card-on-fire") }}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Modal Qty Order -->
                <!-- todo: move to component    -->
                <b-modal
                  id="modal-quantity"
                  :modal-class="terminal && terminal.scale?'popupQuantity':'popup-price'"
                  body-bg-variant="light"
                  no-close-on-backdrop
                  hide-footer
                  no-fade
                >
                  <template
                    slot="modal-header"
                    slot-scope="{ close }"
                  >
                    <b-button
                      variant="outline-light"
                      @click="close()"
                    >
                      {{ $t("quantitypopup.cancel") }}
                    </b-button>
                    <h5>
                      {{ $t("quantitypopup.quantity") }}
                    </h5>
                    <b-button
                      v-if="terminal && terminal.scale"
                      variant="primary"
                      @click="getWeight()"
                    >
                      Get Weight
                    </b-button>
                  </template>

                  <div class="pin-win">
                    <span>{{ quantity.val }} </span>
                  </div>

                  <!-- todo: move to component    -->
                  <div class="pin-keyboard text-center my-0">
                    <ul class="pin-keyboard-list">
                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(1)"
                        >1</span>
                      </li>
                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(2)"
                        >2</span>
                      </li>
                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(3)"
                        >3</span>
                      </li>

                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(4)"
                        >4</span>
                      </li>
                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(5)"
                        >5</span>
                      </li>
                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(6)"
                        >6</span>
                      </li>

                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(7)"
                        >7</span>
                      </li>
                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(8)"
                        >8</span>
                      </li>
                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(9)"
                        >9</span>
                      </li>

                      <li>
                        <span
                          class="pin-key pin-key_call"
                          @click="typeQuantityNum('C')"
                        >C</span>
                      </li>
                      <li>
                        <span
                          class="pin-key"
                          @click="typeQuantityNum(0)"
                        >0</span>
                      </li>
                      <li>
                        <span
                          class="pin-key bg-primary"
                          @click="saveNewQuantity()"
                        >
                          <svg class="icon icon-icon-check">
                            <use xlink:href="#icon-icon-check" />
                          </svg>
                        </span>
                      </li>
                      <li v-if="!isKioskMode">
                        <span
                          class="pin-key"
                          style="opacity: 0"
                        />
                      </li>
                      <li v-if="!isKioskMode">
                        <span
                          class="pin-key"
                          @click="typeQuantityNum('.')"
                        >.</span>
                      </li>
                      <li v-if="!isKioskMode">
                        <span
                          class="pin-key"
                          style="opacity: 0"
                        />
                      </li>
                    </ul>
                  </div>
                </b-modal>
                <b-modal
                  id="modal-salecompleted"
                  class="d-print-none"
                  hide-footer
                  hide-header
                  no-close-on-backdrop
                  modal-class="success-popup"
                  no-fade
                >
                  <div class="text-center modal-complete d-print-none">
                    <svg class="icon icon-icon-success-frame">
                      <use xlink:href="#icon-icon-success-frame" />
                    </svg>

                    <h2>
                      {{ $t("salecompletepopup.sale-completed") }}
                    </h2>

                    <span v-show="behavior === 1">
                      {{ $t("salecompletepopup.change-tender") }}
                    </span>

                    <span v-if="this.lastPaymentType && this.lastPaymentType.behavior === 4">
                      Remaining gift card balance
                    </span>

                    <strong
                      v-if="activeGiftCard && lastPaymentType && lastPaymentType.behavior === 4"
                    >
                      {{ currency }} {{ activeGiftCard.credit.toFixed(2) }}
                    </strong>

                    <strong
                      v-show="behavior === 1"
                      class="text-danger"
                    >
                      {{ currency }} {{ changeAmountLast.toFixed(2) }}
                    </strong>

                    <!-- Dejavoo Tip Display -->
                    <div
                      v-if="lastPaymentType && lastPaymentType.behavior === 5 && lastDejavooTip > 0"
                      class="mt-3 mb-3"
                    >
                      <p
                        class="mb-1 text-success font-weight-bold"
                        style="font-size: 1.1rem;"
                      >
                        Thank the Customer!
                      </p>
                      <p
                        class="mb-1 text-success font-weight-bold"
                        style="font-size: 1.1rem;"
                      >
                        They tipped you!
                      </p>
                      <p
                        class="mb-2 text-success font-weight-bold"
                        style="font-size: 1.8rem;"
                      >
                        {{ currency }}{{ lastDejavooTip.toFixed(2) }}
                      </p>
                      <br>
                    </div>

                    <div class="d-flex justify-content-center align-items-center">
                      <b-button
                        variant="primary"
                        @click="newSale()"
                      >
                        {{ $t("customtippopup.newsale") }}
                      </b-button>
                      <b-button
                        variant="outline-primary"
                        class="ml-2"
                        @click="printCheck()"
                      >
                        Print Receipt
                      </b-button>
                    </div>
                  </div>
                </b-modal>
                <b-modal
                  id="modal-kiosksalecompleted"
                  class="d-print-none"
                  hide-footer
                  hide-header
                  no-close-on-backdrop
                  modal-class="success-popup modal-kiosk"
                  no-fade
                >
                  <div class="text-center modal-complete d-print-none">
                    <svg class="icon icon-icon-success-frame-w">
                      <use xlink:href="#icon-icon-success-frame-w" />
                    </svg>

                    <h2 class="text-success">
                      {{ $t("salecompletepopup.sale-completed") }}
                    </h2>

                    <h2
                      v-show="behavior === 1 || isKioskMode"
                      class="text-dark mb-4"
                    >
                      Order # {{ currentOrder["id"] }}
                    </h2>
                    <p class="mb-4">
                      <span v-if="currentOrder.payments.length===0">
                        Please take your receipt and go to the nearest register to pay for your order.
                      </span>
                      <span v-if="currentOrder.payments.length>0">
                        Your order is now being prepared.
                      </span>
                    </p>

                    <div class="d-flex justify-content-center align-items-center">
                      <b-button
                        variant="outline-primary"
                        class="w-100"
                        @click="() => $router.push('/')"
                      >
                        Close
                      </b-button>
                    </div>
                  </div>
                </b-modal>
              </div>

              <CheckoutPaymentButtons
                v-if="!isKioskMode"
                wrapper-class="d-none d-lg-flex"
                :payment-types="paymentTypes"
                :amount-tendered="amountTendered"
                :refund-order-id="refundOrderId"
                :is-payment-processing="isPaymentProcessing"
                :min-tendered="0"
                @pay="!isPaymentProcessing ? pay($event) : null"
              />
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
    <div
      class="d-none d-print-block"
      style="z-index: 100000; width: 100%; position: absolute"
    >
      <PdfReceiptView :order="currentOrder" />
    </div>
    <ModalError
      :id="'modal-error-checkout'"
      :error="error"
      @retry-payment="retryPayment"
    />
    <ProcessingModal
      modal-title="Waiting for Card Reader..."
      :show-cancel="!!pendingDejavooPaymentType"
      @cancel="cancelDejavooTransaction"
    />
    <SelectCustomerModal
      :order-customer="currentOrder.customer"
      @select-customer="selectCustomer"
      @remove-customer="removeCustomerFromOrder"
    />
    <CustomerModalSimple
      @select-customer-after-add="selectCustomer"
    />
    <EnterPinModal @verify-action="verifyAction" />
    <scale-loader
      :loading="isLoad"
      :color="'#007bff'"
    />
    <leaveCurrentOrderModal
      @cancel-order="cancelOrder()"
    />
    <HoldOrder @hold-order="holdOrder" />
    <SurchargeModal
      :surcharge-value="surchargeValue"
      :order-grand-total="amountTendered"
      @surcharge="addSurcharge"
      @cancelSurcharge="cancelSurcharge"
    />
    <GiftCardModal
      :gift-card-checkout="true"
      :checkout-amount="amountTendered"
      @payFromGiftCard="payFromGiftCard"
    />
    <GiftVoucherUnAvailable />
    <DejavooPartialApprovalModal
      :approved-amount="partialApprovalData.approvedAmount"
      :remaining-balance="partialApprovalData.remainingBalance"
      :is-voiding="partialApprovalData.isVoiding"
      @continue-to-pay="handleContinueToPay"
      @void-transaction="handleVoidPartialPayment"
    />
  </pos-layout>
</template>

<script>
import router from "@/router";
import { getOrderFinalTotal } from "@/pricing";
import { ORDER_STATUS } from "@/helpers/order/status";
import {
  PAYMENT_BEHAVIOR,
  PAYMENT_REVERSAL_TRANSACTION_TYPE,
} from "@/helpers/order/payment/behavior";
import orderMixin from "@/mixins/order/orderMixin";
import shiftMixin from "@/mixins/shiftMixin";
import printMixin from "@/mixins/printMixin";
import scaleMixin from "@/mixins/scaleMixin";
import { openDrawer } from "@/helpers/printHelper";
import EnterPinModal from "@/modals/EnterPinModal";
import PosLayout from "@/layouts/PosLayout";
import ModalError from "@/modals/ModalError";
import ProcessingModal from "@/modals/ProcessingModal";
import SelectCustomerModal from "@/modals/SelectCustomerModal";
import CustomerModalSimple from "@/modals/CustomerModalSimple";
import orderModifierMixin from "@/mixins/order/modifier";
import { TAX_OPTION } from "@/helpers/store/tax_options";
import PdfReceiptView from "@/components/PdfReceiptView";
import ScaleLoader from "vue-spinner/src/ScaleLoader.vue";
import syncMixin from "@/mixins/syncMixin";
import { TRANSACTION_TYPE } from "@/helpers/order/transaction/types";
import {
  getOrderDiscountMismatch,
  normalizeOrderDiscounts,
} from "@/helpers/order/normalizeOrderDiscounts";
import { mapActions, mapGetters } from "vuex";
import cdOrderMixin from "@/mixins/cdOrderMixin";
import LeaveCurrentOrderModal from "@/modals/Order/LeaveCurrentOrderModal.vue";
import HoldOrder from "@/modals/Order/MoreOptions/HoldOrder.vue";
import SurchargeModal from "@/modals/SurchargeModal.vue";
import GiftCardModal from "@/modals/Order/MoreOptions/GiftCardModal.vue";
import GiftVoucherUnAvailable from "@/modals/GiftVoucherUnAvailable.vue";
import { toFixedNoRounding } from "@/helpers/utils";
import {
  getDejavooFeeAmount,
  getDejavooVoidParamsFromSaleResponse,
  makeDejavooAbortTransaction,
  makeDejavooPayment,
  makeDejavooRefund,
  makeDejavooVoid,
  parseDejavooConfig,
  serializeDejavooProcessorResponse,
} from "@/helpers/payments/Dejavoo";
import { sendDejavooCart } from "@/helpers/payments/DejavooCart";
import { makeWindcavePayment } from "@/helpers/payments/Windcave";
import DejavooPartialApprovalModal from "@/modals/DejavooPartialApprovalModal.vue";
import CheckoutTenderPad from "@/components/OrderCheckout/CheckoutTenderPad.vue";
import CheckoutPaymentButtons from "@/components/OrderCheckout/CheckoutPaymentButtons.vue";
import CheckoutOrderSidebar from "@/components/OrderCheckout/CheckoutOrderSidebar.vue";
import DashboardService from "@/services/dashboard-service";
import indexDbService from "@/helpers/dbHelper";
import {ORDER_QUEUE_DEBOUNCE_INTERVAL_IN_MS} from "@/store/appConstants";
import { APP_VERSION } from "@/helpers/appVersion";
import { isTerminalSettingEnabled } from "@/helpers/terminal/settings";
import { resolveItemDisplayName } from "@/services/order/orderDomain";
import { getPaymentProcessor } from "@/services/payment";

export default {
	name: "OrderCheckout",
	components: {
		PosLayout,
		EnterPinModal,
		ModalError,
		ProcessingModal,
		SelectCustomerModal,
		CustomerModalSimple,
		PdfReceiptView,
    ScaleLoader,
    LeaveCurrentOrderModal,
    HoldOrder,
    SurchargeModal,
    GiftCardModal,
    GiftVoucherUnAvailable,
    DejavooPartialApprovalModal,
    CheckoutTenderPad,
    CheckoutPaymentButtons,
    CheckoutOrderSidebar
	},
	mixins: [orderMixin, printMixin, scaleMixin, orderModifierMixin, shiftMixin, syncMixin, cdOrderMixin],
	data () {
		return {
			error: {
				title: "Unknown error...",
				info: "Please, contact support"
			},
			lastPaymentType: null,
			lastDejavooTip: 0,
			sidebarMob: true,
			baseURL: localStorage.baseURL,
			itemIdCounter: 0,
			currentEmployee: null,
			quantity: {
				val: "",
				changed: false
			},
			// Phase 3 keystone: `currentOrder` is a computed get/set proxy over the
			// Vuex `orders` state (single source of truth), keyed by `activeOrderKey`.
			// `draftActiveOrder` is the pre-persist fallback the proxy returns when no
			// store order is bound yet.
			draftActiveOrder: {
				localID: 0,
				subtotal: 0,
				items: [],
				table: undefined,
				discount_total: 0,
        order_discount: 0,
				tax_total: 0,
				payments: [],
				customer: null,
				cash_discount: false,
        allow_surcharge:false,
        order_gift_card_payment:[]
			},
			activeOrderKey: null,
			amountTenderedString: "0",
			isAmountPreFilled: false,
			table: null,
			isDisplayPaymentDetails: false,
			behavior: PAYMENT_BEHAVIOR.ALLOW_CHANGE,
			longPress: {
				interval: false,
				count: 0
			},
			isPaymentProcessing: false,
			pendingDejavooPaymentType: null,
			dejavooTransactionCancelled: false,
			isVerified: true,
      isLoad: false,
      refundTenderedAmount:false,
      surchargeValue:0,
      currentPaymentSurcharge: 0,
      isGiftCardPayment:false,
      partialApprovalData: {
        approvedAmount: 0,
        remainingBalance: 0,
        isVoiding: false,
        paymentType: null,
        referenceId: null,
        transactionType: null,
        urlField: null,
        lastPaymentObject: null
      },
      queueSyncTimeout: null,
      queueSyncTimeoutDebounce: ORDER_QUEUE_DEBOUNCE_INTERVAL_IN_MS,
      checkoutInitializing: true,
      // Set to true in beforeDestroy so the currentOrder watcher stops scheduling
      // new queue syncs while the component is tearing down.
      isDestroyingComponent: false,
		};
	},
  computed: {
    ...mapGetters({
      orders:"orders/getAllOrders",
      refundOrderId: 'orders/refundOrderId',
      tables: "config/getAllTables",
      isSurcharged:"surcharge/isSurcharged",
      updatingGiftCardPayments:"orders/updatingGiftCardPayments",
      activeGiftCard:'giftVoucher/activeGiftCard',
      isGiftCardPaymentInitiated:'giftVoucher/isGiftCardPaymentInitiated',
      selectedGiftCards:'giftVoucher/selectedGiftCards',
      customerDisplayEnabled: "customerDisplay/isEnabled",
      isProduct86d: "products86d/isProduct86d"
    }),
    // ── Active-order proxy (Phase 3 keystone), mirrors StandardOrder.vue ─────
    currentOrder: {
      get() {
        if (this.activeOrderKey != null) {
          const stored = this.$store.getters["orders/getOrderByIdOrLocalId"](this.activeOrderKey);
          if (stored) return stored;
        }
        return this.draftActiveOrder;
      },
      set(value) {
        if (!value) {
          this.draftActiveOrder = value;
          this.activeOrderKey = null;
          return;
        }
        const key = value.id || value.local_id;
        if (key != null) {
          const existing = this.$store.getters["orders/getOrderByIdOrLocalId"](key);
          if (!existing) {
            this.$store.dispatch("orders/saveOrder", value);
          }
          this.activeOrderKey = key;
        } else {
          this.draftActiveOrder = value;
          this.activeOrderKey = null;
        }
      },
    },
    // Stable business-state signature (volatile sync fields excluded) so a
    // saveOrder restamp doesn't re-trigger the queue sync and loop.
    orderBusinessSignature() {
      const o = this.currentOrder;
      if (!o) return "";
      // eslint-disable-next-line no-unused-vars
      const { updated_at, synced_at, updated, created_at, ...rest } = o;
      try {
        return JSON.stringify(rest);
      } catch (e) {
        return String(Date.now());
      }
    },
		terminal () { return this.$store.getters["config/terminal"];},
		products () { return this.$store.getters["config/products"];},
		employee () { return this.$store.getters["employee"];},
		store () { return this.$store.getters["config/store"];},
    isRetailMode() {
      // Check if retail_mode db_setting is true
      return isTerminalSettingEnabled(this.terminal, 'retail_mode');
    },
    showCashCardPrice() {
      return isTerminalSettingEnabled(this.terminal, 'show_cashcardprice');
    },
		isKioskMode () {
			return this.$store.getters["config/isKioskMode"];
		},
    changeAmountLast() {
      if (this.currentOrderSumAmount < 0.0 && this.currentOrderSum < 0.0) {
        return parseFloat(this.currentOrderSum.toFixed(2))
      }
      // Sum up all change_amount from payments to get the total change
      let totalChange = 0;
      if (this.currentOrder.payments) {
        this.currentOrder.payments.forEach((payment) => {
          totalChange += payment.change_amount || 0;
        });
      }
      return parseFloat(totalChange.toFixed(2));
		},
	currentOrderSumAmount () {
		let sumAmount = 0;
		if (this.currentOrder.payments) {
			this.currentOrder.payments.map((payment) => {
				// Use amount_paid instead of amount to accurately track what was actually applied to the order
				// amount_paid accounts for cases where amount > remaining balance
				sumAmount += payment.amount_paid || payment.amount;
			});
		}
		return parseFloat(sumAmount.toFixed(2));
	},
    terminalMode () {
			return this.$store.getters.terminalMode;
		},
		currentOrderSum () {
			// Single pricing engine: grand_total + surcharge_value + tips_total
			return getOrderFinalTotal(this.currentOrder);
		},
		currentOrderGrandTotalSum () {
      const difference = this.currentOrderSum - this.currentOrderSumAmount;
      return parseFloat(difference.toFixed(2))
		},
    creditPricingPaymentType() {
      return this.paymentTypes.find((paymentType) => paymentType.surcharge > 0) || null;
    },
    // Cash-discount dual pricing: shown when show_cashcardprice is on, the
    // terminal has the cash_discount feature enabled, and there is no surcharge
    // payment type (that path has its own dual pricing). Cash price = the
    // discounted / toggle-ON total, Card price = the pre-discount / toggle-OFF
    // total — derived from the live total in whichever direction the toggle is
    // currently set, mirroring the receipt (printHelper) calc.
    cashDiscountDualPricing() {
      return this.showCashCardPrice
        && this.currentOrderGrandTotalSum > 0
        && !this.creditPricingPaymentType
        && !!this.allowCashDiscount
        && this.allowCashDiscount.value === 'true';
    },
    hasDualPricing() {
      return this.cashDiscountDualPricing
        || (this.showCashCardPrice
          && this.currentOrderGrandTotalSum > 0
          && !!this.creditPricingPaymentType);
    },
    creditCardSurchargePercent() {
      return this.creditPricingPaymentType?.surcharge || 0;
    },
    creditCardSurchargeAmount() {
      if (!this.creditCardSurchargePercent) return 0;

      return parseFloat(
        this.surchargeCharged(this.currentOrderGrandTotalSum, this.creditCardSurchargePercent).toFixed(2),
      );
    },
    cashPrice() {
      if (this.cashDiscountDualPricing) {
        const cashTotal = (this.currentOrder && this.currentOrder.cash_discount)
          ? this.currentOrderGrandTotalSum
          : this.currentOrderGrandTotalSum / this.cashDiscountFactor;
        return parseFloat(cashTotal.toFixed(2));
      }
      return parseFloat(this.currentOrderGrandTotalSum.toFixed(2));
    },
    creditCardPrice() {
      if (this.cashDiscountDualPricing) {
        // "Non-cash" / toggle-OFF total. When the toggle is on the live total is
        // already discounted, so scale it back up by the cash-discount factor.
        const cardTotal = (this.currentOrder && this.currentOrder.cash_discount)
          ? this.currentOrderGrandTotalSum * this.cashDiscountFactor
          : this.currentOrderGrandTotalSum;
        return parseFloat(cardTotal.toFixed(2));
      }
      return parseFloat((this.currentOrderGrandTotalSum + this.creditCardSurchargeAmount).toFixed(2));
    },
    amountTendered() {
      return parseFloat(this.amountTenderedString ? this.amountTenderedString : "0") / 100;

		},
		amountChange: function () {
      const difference = parseFloat((this.amountTendered - this.currentOrderGrandTotalSum).toFixed(2));
      if(this.currentOrderSum > 0.0)
        return difference > 0.0 ? difference : 0;
      else
      return difference
		},
		quickCash: function () {
      if (this.currentOrderSum < 0.00)
        return []
			const choices = [];
			let coefficient = 0;
			const multiplier = 10;

			do {
				if (!coefficient) {
					choices.push(Math.ceil(this.currentOrderGrandTotalSum));
					coefficient = multiplier;
					continue;
				}
				let result = Math.ceil(this.currentOrderGrandTotalSum / coefficient) * coefficient;
				if (choices.find(choice => choice === result)) {
					result = Math.max(...choices) + this.currentOrderGrandTotalSum;
				}
				choices.push(Math.round(result));
				coefficient *= multiplier;
			} while (choices.length < 3);

			return choices;
		},
		currency () {
			return this.$store.getters["config/currency"];
		},
    displayOrderWithTable() {
      const orderId = this.currentOrder.id || this.currentOrder.local_id;

      // If order has a table, get the table name
      if (this.currentOrder.table) {
        const table = this.$store.getters["config/getTableById"](this.currentOrder.table);
        if (table && table.table_name) {
          return `${table.table_name} / ${orderId}`;
        }
      }

      return orderId;
    },
    // giftCardPaymentAmount(){
    //   const giftCardAmountArray =  this.currentOrder.order_gift_card_payment.map(payment=>payment.amount_paid)
    //   return parseFloat(giftCardAmountArray.reduce((acc,amount)=> acc+amount))
    // }
	},
	watch: {
    // Replaces the removed deep `currentOrder` watcher. currentOrder is now the
    // live Vuex object; watching the business signature fires on real edits only
    // (a saveOrder restamp of volatile sync fields won't loop).
    orderBusinessSignature() {
      if (this.checkoutInitializing || this.isPaymentProcessing || this.isDestroyingComponent) return;
      // Terminal-status orders are enqueued by their own close/cancel/refund flow.
      // The watcher must not schedule an additional open-order update.
      const status = this.currentOrder && this.currentOrder.status;
      if (status === ORDER_STATUS.COMPLETED ||
          status === ORDER_STATUS.CANCELLED ||
          status === ORDER_STATUS.REFUNDED) return;
      this.scheduleQueueSync();
    },
		paymentTypes () {
			if (!this.isPaymentTypesAvailable) router.go(-1);
    },
    // Keep the prefilled tender amount in sync with the live order total, e.g.
    // when Cash Discount is toggled on/off at checkout. Only while the amount is
    // still the auto-filled value and nothing has been paid yet, so a manually
    // typed amount is never overwritten.
    currentOrderGrandTotalSum (newTotal) {
      if (this.checkoutInitializing || this.isPaymentProcessing || this.isDestroyingComponent) return;
      if (this.refundOrderId || !this.isAmountPreFilled) return;
      if (this.currentOrder && this.currentOrder.payments && this.currentOrder.payments.length > 0) return;
      this.amountTenderedString = Math.round(Math.max(0, newTotal) * 100).toString();
    },
    "currentOrder.isActive": {
      handler(isActive) {
        try {
           // setting active state in order to control the showing of leaveCurrentModal on the isActive attribute
            if (isActive)
              this.setActiveOrderState(true)
            else {
              this.setActiveOrderState(false)
            }
        }
        catch (err) {
          //pass
        }
      },
      immediate: true

    },
    updatingGiftCardPayments:{
      handler(payments){
        if(payments.length>0)
        this.currentOrder.order_gift_card_payment = [...payments]
          // this.currentOrder.order_gift_card_payment.forEach(payment=>{
          //   let foundPayment = null
          //   foundPayment = payments.find(updatedPayment=>updatedPayment.local_id === payment.local_id)
          //   if(foundPayment){
          //     payment = foundPayment
          //   }
          // })
      },
      immediate:true
    },
},
  async created() {
    this.$root.$on('cd-pos-update', this.handleCdPosUpdate);
    if (this.orders.length === 0)
        await this.fetchOrdersFromDb()
      if(this.products.length === 0)
        await this.fetchProductsFromDb()
    if (this.tables.length === 0)
      await this.fetchTablesFromDb()

    const orderKey = this.$route.params.id.toString().includes("_") ? this.$route.params.id
        : parseInt(this.$route.params.id);
    const existingOrder = this.$store.getters["orders/getOrderByIdOrLocalId"](orderKey);
    if (existingOrder) {
      // Bind the proxy to the live store order (single source of truth).
      this.currentOrder = existingOrder;
    } else {
      console.warn("Order not found in store immediately, using route params");
      this.currentOrder.id = orderKey;
      this.currentOrder.local_id = orderKey;
    }
    // this.currentOrder = {...this.$store.getters["orders/getOrderByIdOrLocalId"](orderKey)};
    const currentOrderItems = this.currentOrder.items
    this.currentOrder.items = currentOrderItems.map(item => {
      const productConfig = this.products.find(product => product.id === item.product)
      // Only update printers if product config exists and has printers
      if (productConfig && productConfig.printers && productConfig.printers.length > 0) {
        item.printers = productConfig.printers
      }
      // Attach gift card number for gift card items (product === -2)
      if (item.product === -2) {
        const giftCardInfo = this.selectedGiftCards.find(card => card.order_item_local_id === item.local_id)
        if (giftCardInfo) {
          item.gift_card_number = giftCardInfo.card_number
        }
      }
      // Preserve existing has_kitchen_updates and sent_to_kitchen flags
      // Don't reset them based on product config
      return item;
    });

    // Reconcile totals at open: if the order arrived with line-style item
    // discounts or a discount_total that does not match its items, fix the
    // items and rebuild the totals so the checkout displays (and prefills)
    // the correct amount. Healthy orders are left untouched so server
    // totals are preserved.
    const isClosedOrder = this.currentOrder.status === ORDER_STATUS.COMPLETED ||
      this.currentOrder.status === ORDER_STATUS.REFUNDED ||
      this.currentOrder.status === ORDER_STATUS.CANCELLED;
    if (!this.refundOrderId && !isClosedOrder && (this.currentOrder.grand_total || 0) >= 0) {
      const normalizedOrder = normalizeOrderDiscounts(this.currentOrder);
      const discountsWereLineStyle = normalizedOrder !== this.currentOrder;
      if (discountsWereLineStyle) {
        this.currentOrder.items = normalizedOrder.items;
      }
      if (discountsWereLineStyle || getOrderDiscountMismatch(this.currentOrder)) {
        const previousTotal = (this.currentOrder.grand_total || 0);
        this.countSubtotal();
        this.$store.dispatch("orders/saveOrder", this.currentOrder);
        const message =
          `[Checkout] Order totals reconciled on open: ` +
          `${previousTotal.toFixed(2)} -> ${(this.currentOrder.grand_total || 0).toFixed(2)} ` +
          `(order ${this.currentOrder.id || this.currentOrder.local_id})`;
        console.warn(message);
      }
    }

    this.amountTenderedString = Math.round(this.currentOrderGrandTotalSum * 100).toString();
    this.isAmountPreFilled = true;

      if(this.currentOrder.status === ORDER_STATUS.COMPLETED || this.currentOrder.status === ORDER_STATUS.REFUNDED){
        if(this.isKioskMode){
          this.$bvModal.show("modal-kiosksalecompleted")
        }
        else{
          this.$bvModal.show("modal-salecompleted")
        }
      }

    this.$nextTick(() => { this.checkoutInitializing = false; });
  },
	beforeMount: async function () {
		this.is_tax_inclusive = this.store.tax_option == TAX_OPTION.TAX_INCLUSIVE;
	},
  mounted(){
    window.addEventListener("beforeunload", this.forceQueueSync);

    if(this.currentOrder.status === ORDER_STATUS.COMPLETED || this.currentOrder.status === ORDER_STATUS.REFUNDED){
      if(this.isKioskMode){
          this.$bvModal.show("modal-kiosksalecompleted")
        }
        else{
          this.$bvModal.show("modal-salecompleted")
        }
      }
  },
  async beforeDestroy() {
    // Stop the watcher from scheduling new syncs while we're tearing down.
    this.isDestroyingComponent = true;
    window.removeEventListener("beforeunload", this.forceQueueSync);
    await this.forceQueueSync();

    this.$root.$off('cd-pos-update', this.handleCdPosUpdate);

    // reset all the value related to surcharge on destroy of component
    this.currentOrder.surcharge_value = 0
    this.setSurcharge(false)

    if (this.currentOrder.status === ORDER_STATUS.OPEN || this.currentOrder.status === ORDER_STATUS.HOLD) {
      this.currentOrder.locked_by = null;
      await this.getOrderSync().flush({ queue: true, trigger: "checkout_before_destroy" });
    }
    if (this.$route.name === "Tables") {
      await this.$store.dispatch('toggleCallOrderList', true)
    }
	},
  methods: {
    ...mapActions('orders', ['setRefundOrderId','fetchOrdersFromDb']),
    ...mapActions('config',['fetchProductsFromDb','fetchTablesFromDb']),
    ...mapActions('surcharge',['setSurcharge']),
    ...mapActions('giftVoucher',['fetchGiftCardPayments', 'updateGiftCardCredits', 'recordGiftCardPayments','toggleGiftCardPaymentInitiater']),
    ...mapActions({
      sendMessage: 'customerDisplay/sendMessage',
    }),
    async forceQueueSync() {
      if (!this.currentOrder) return;
      const orderId = this.currentOrder.id || this.currentOrder.local_id;
      if (!orderId) return;

      const hasContent = (this.currentOrder.items && this.currentOrder.items.length > 0) ||
                         (this.currentOrder.payments && this.currentOrder.payments.length > 0);
      if (!hasContent) return;

      await this.getOrderSync().flush({ queue: true, trigger: "checkout_force_sync" });
    },
    hasUnavailable86dItems() {
      return (this.itemsAtCurrentOrder || []).some((item) =>
        item && item.product && this.isProduct86d(item.product)
      );
    },
    showUnavailable86dCheckoutError() {
      this.showModalError(
        "Unavailable item",
        "One or more items in this order are out of stock (86). Remove them before completing payment."
      );
    },
    waitForOrderIdBeforeQueueSync() {
      if (!this.currentOrder) return null;
      if (this.currentOrder.id) return this.currentOrder;

      const localId = this.currentOrder.local_id;
      if (!localId) return this.currentOrder;

      const resolvedOrder = this.$store.getters['orders/getOrderByIdOrLocalId'](localId);
      if (resolvedOrder) {
        this.currentOrder = resolvedOrder;
      }

      return this.currentOrder;
    },
    scheduleQueueSync() {
      // Debounced queue sync routed through the single OrderSyncCoordinator.
      this.getOrderSync().schedule({ queue: true, trigger: "checkout_force_sync" });
    },
    toFixedNoRounding,
    async handleCdPosUpdate(payload) {
      if (!payload) return;
      const data = payload.data || payload;
      const { action, phone } = data;

      if (action === 'tip-update') {
        const { tip_amount, order_id, local_id } = data;

        if ((this.currentOrder.id && this.currentOrder.id === order_id) || (this.currentOrder.local_id && this.currentOrder.local_id === local_id)) {
          this.$set(this.currentOrder, 'tips_total', tip_amount);
          this.lastDejavooTip = tip_amount;
          this.$store.dispatch("orders/saveOrder", this.currentOrder);
        }
      }

      if (action === 'add-customer' && phone) {
        const normalizePhone = (value) => {
          if (!value) return ''
          const digits = String(value).replace(/\D/g, '')
          if (digits.length === 11 && digits[0] === '1') return digits
          if (digits.length === 10) return `1${digits}`
          return digits
        }

        const targetDigits = normalizePhone(phone)
        const isPhoneMatch = (customerPhone) => {
          const customerDigits = normalizePhone(customerPhone)
          return !!customerDigits && customerDigits === targetDigits
        }

        let foundCustomer = null;

        try {
          const cached = await indexDbService.getDbData('customers');
          const cachedCustomers = Array.isArray(cached) ? cached : [];
          foundCustomer = cachedCustomers.find(c => isPhoneMatch(c.phone));
        } catch (e) {
          console.error(e)
        }

        if (!foundCustomer && this.isOnline) {
          try {
            const response = await DashboardService.getCustomersList({
              search: phone,
              page: 1
            })
            const results = (response && response.results) ? response.results : []
            foundCustomer = results.find(c => isPhoneMatch(c.phone)) || results[0] || null

            if (foundCustomer) {
              indexDbService.saveToDb('customers', foundCustomer).then()
              this.$store.commit('customers/save', foundCustomer)
            }
          } catch (e) {
            console.error(e)
          }
        }

        if (foundCustomer) {
          this.selectCustomer(foundCustomer);

          setTimeout(() => {
            this.sendOrderToChannel(this.currentOrder);
          }, 300);
        } else {
          // Check if customer_disable_name is enabled
          const isNameDisabled = isTerminalSettingEnabled(this.terminal, 'customer_disable_name');

          if (isNameDisabled) {

            // Parse phone number to extract country code and body
            let phoneValue = phone;
            // Ensure phone has country code prefix
            if (!phone.startsWith('+')) {
              // Assume US/Canada if no prefix
              const digitsOnly = phone.replace(/\D/g, '');
              if (digitsOnly.length === 10) {
                phoneValue = '+1' + digitsOnly;
              } else if (digitsOnly.length === 11 && digitsOnly.startsWith('1')) {
                phoneValue = '+' + digitsOnly;
              } else {
                phoneValue = '+1' + digitsOnly;
              }
            }

            // Generate customer name from last 4 digits of phone
            const phoneDigits = phoneValue.replace(/\D/g, '');
            const last4Digits = phoneDigits.slice(-4);
            const customerName = `Cust.${last4Digits}`;

            const newCustomer = {
              first_name: customerName,
              last_name: null,
              phone: phoneValue,
              email: null,
              notes: null,
              local_id: (new Date).toISOString(),
              addresses: [],
              default_address: null
            };

            this.$store.commit('customers/save', newCustomer);
            indexDbService.saveToDb('customers', newCustomer).then();
            this.selectCustomer(newCustomer);

            setTimeout(() => {
              this.sendOrderToChannel(this.currentOrder);
            }, 300);
          } else {
            this.$bvModal.show("customer-modal-simple");

            setTimeout(() => {
              this.$root.$emit('set-customer-modal-phone', phone);
              this.$root.$emit('focus-customer-modal-input');
            }, 200);
          }
        }
      }
    },
    async handleKitchenPrint() {
      this.localKitchenPrintProcessing = true;
      try {
        await this.printKitchenCheck();
      } catch (e) {
        this.localKitchenPrintProcessing = false;
        this.error.title = 'Kitchen Printer Error';
        this.error.info = 'Could not print to kitchen. Please check printer connection.';
        this.$bvModal.show('modal-error-checkout');
        return;
      }
      this.localKitchenPrintProcessing = false;
    },
		async goToTableOrders () {
			await this.$router.push({ name: "TableOrders", params: { id: this.currentOrder.table } });
		},
		async verifyAction (employee) {

			if (!employee) {
				return this.isVerified = false;
			}
			this.isVerified = true;
			await this.cancelOrderProcessing({ voidReason: this.lockedVoidReason });
			this.lockedVoidReason = null;

			this.isVerified = false;

			return this.$bvModal.hide("enter-pin-modal");
		},
		showSelectCustomerModal () {
			// If customer is already assigned, always show the select modal to allow changing/removing
			if (this.currentOrder.customer) {
				return this.$bvModal.show("select-customer-modal");
			}

			// Check if add_customer_direct setting is enabled
			const isDirectMode = isTerminalSettingEnabled(this.terminal, 'add_customer_direct');

			if (isDirectMode) {
				// Directly open the simplified customer modal
				return this.$bvModal.show("customer-modal-simple");
			}

			return this.$bvModal.show("select-customer-modal");
		},
		async selectCustomer (customer) {
			await this.assignCustomerToOrder(customer);
			setTimeout(() => {
				this.sendOrderToChannel(this.currentOrder);
			}, 300);
		},
		removeCustomerFromOrder() {
			// Mutate the live store-backed order in place (proxy = single source of
			// truth); the former JSON clone-reassign was only a reactivity nudge.
			const currentOrder = this.currentOrder;
			currentOrder.customer = null;
			currentOrder.items.forEach(item => {
				item.price = item.default_price;
				item.price_base = item.default_price;
			});
			this.calculateAllItemTaxes();
			this.sync();
			setTimeout(() => {
				this.sendOrderToChannel(this.currentOrder);
			}, 300);
		},
		receiveMessage (event) {
			const self = this;
			if (event.data.action !== "sync") {
				self.updateLocalId(event.data);
			}
		},
		start () {
			if (!this.interval) {
				this.longPress.interval = setInterval(() => {
					this.longPress.count++;
					if (this.longPress.count === 50) {
						this.printCheck();
					}
				}, 30);
			}
		},
		stop () {
			clearInterval(this.longPress.interval);
			this.longPress.interval = false;
			this.longPress.count = 0;
		},
		sidebarMobToggle () {
			this.sidebarMob = !this.sidebarMob;
		},
		typeNum (num) {
			num = num === "" ? 0 : num;
			this.amountTenderedString = num + "";
		},
		typeQuantityNum: function (num, quantityVal = null) {
			if (num === "C") {
				this.quantity.val = "";
			} else if (typeof num !== "undefined" && !quantityVal) {
				if (this.quantity.changed) {
					this.quantity.val += num.toString();
				} else {
					this.quantity.val = num.toString();
				}
				this.quantity.changed = true;
			} else if (quantityVal) {
				this.quantity.val = quantityVal;
			}
		},
		resetNum () {
			this.amountTenderedString = Math.round(this.currentOrderGrandTotalSum * 100).toString();
			this.isAmountPreFilled = true;
		},
		typeCustom (amount) {
      this.isAmountPreFilled = false;
      this.amountTenderedString = Math.round(parseFloat(amount) * 100) + "";
		},
		sum: function (items, prop) {
			return items.reduce(function (a, b) {
				return a + b[prop] * b["quantity"];
			}, 0);
		},
		async updateLocalId (msgObj) {
			if (!this.currentOrder || !this.currentOrder.id) return false;
			if (this.currentOrder.id === msgObj.localID) {
				this.currentOrder.id = msgObj.remoteID;
			}
		},
		async timeout (ms, promise, controller) {
			return new Promise(function (resolve, reject) {
				setTimeout(function () {
					reject(new Error("timeout"));
					controller.abort();
				}, ms);
				promise.then(resolve, reject);
			});
		},

    async sendNABancardRequest (paymentType, amount, surchargeValue=0) {
			if (paymentType.behavior !== PAYMENT_BEHAVIOR.NABANCARD_INTEGRATION) {
				await this.$bvModal.hide("processing-modal");
				return null;
			}
			const url = paymentType.url;
			if (!url) return false;
			const headers = new Headers({
        "Cache-Control": "no-cache",
				"Content-type": "application/xml",
				"Host": url.replace("http://", "").replace("https://", "")
			});

      let body = null
      if(this.refundTenderedAmount){
        // Check if the entire order total is negative
        const isEntireOrderNegative = this.currentOrderGrandTotalSum < 0;

        // Use CCR9 only when the entire order is negative, otherwise use the regular transaction type (CCR1)
        const transactionType = isEntireOrderNegative ?
          PAYMENT_REVERSAL_TRANSACTION_TYPE[paymentType.transaction_type] :
          paymentType.transaction_type;

        // Include surcharge in the amount if it's a positive total order
        const totalAmount = isEntireOrderNegative ?
          (-1 * parseFloat(amount)).toFixed(2) :
          (parseFloat(amount) + parseFloat(surchargeValue)).toFixed(2);

        body = `<DETAIL><TRAN_TYPE>${transactionType}</TRAN_TYPE><AMOUNT>${totalAmount}</AMOUNT></DETAIL>`;
      } else{
		body = `<DETAIL><TRAN_TYPE>${paymentType.transaction_type}</TRAN_TYPE><AMOUNT>${(parseFloat(amount)+parseFloat(surchargeValue)).toFixed(2)}</AMOUNT></DETAIL>`;
      }

		// Store the request body for logging
		this.lastNABancardRequest = body;

		const self = this;
		let paymentResponse;
		const controller = new AbortController();
		const signal = controller.signal;
		await this.timeout(180000, fetch(url, {
				method: "post",
				signal: signal,
				mode: "cors",
				headers,
				body
			}), controller).then(response => response.text())
				.then(data => {
					self.$bvModal.hide("processing-modal");

					paymentResponse = data;
				}).catch(function (error) {
					console.error(error);
					self.$bvModal.hide("processing-modal");
					self.showModalError("Payment Error", "Unsuccessful");

					paymentResponse = "";
				});
			return paymentResponse;
		},
		async retryPayment() {
			// Show processing modal before closing error modal to prevent flicker
			await this.$bvModal.show("processing-modal");
			this.$bvModal.hide("modal-error-checkout");

			return this.pay(this.lastPaymentType);
		},
		async NABancardPaymentProcessing (paymentType, amount) {
			const defaultEmptyResponse = {
				response: "",
				NABancardResponseObject: {}
			};
			let response = "";
			const NABancardResponseObject = {};
			try {
				await this.$bvModal.show("processing-modal");
        const surchargeAmount = this.currentPaymentSurcharge ? this.currentPaymentSurcharge : 0
				response = await this.sendNABancardRequest(paymentType, amount, surchargeAmount);
				this.$bvModal.hide("processing-modal");
				if (!response) {
					this.showModalError("Payment Error", "Unsuccessful");
					return defaultEmptyResponse;
				}
				const parser = new DOMParser();
				const xmlDoc = parser.parseFromString(response, "application/xml");

				// Safely extract response text with defensive checks
				const responseTextElement = xmlDoc.getElementsByTagName("AUTH_RESP_TEXT")[0];
				NABancardResponseObject.response_text = (responseTextElement && responseTextElement.childNodes && responseTextElement.childNodes[0])
					? responseTextElement.childNodes[0].nodeValue
					: 'Unknown';

				// Safely extract response code with defensive checks
				const responseCodeElement = xmlDoc.getElementsByTagName("AUTH_RESP")[0];
				NABancardResponseObject.response_code = (responseCodeElement && responseCodeElement.childNodes && responseCodeElement.childNodes[0])
					? responseCodeElement.childNodes[0].nodeValue
					: '';
				let tips = 0;
				try {
					const tipElement = xmlDoc.getElementsByTagName("TIP_AMT")[0];
					if (tipElement && tipElement.childNodes && tipElement.childNodes[0]) {
						tips = tipElement.childNodes[0].nodeValue;
						NABancardResponseObject.tips = tips ? parseFloat(tips) : 0;
					} else {
						NABancardResponseObject.tips = 0;
					}
				} catch (e) {
					// Gracefully handle missing TIP_AMT element - this is expected for some transactions
					console.warn("Could not parse tips from NABancard response");
					NABancardResponseObject.tips = 0;
				}
				// Store the full XML response for logging
				NABancardResponseObject.full_response = response;
				// Get the request body that was sent (from the sendNABancardRequest call)
				const requestBody = this.lastNABancardRequest || "Request not captured";
				if (NABancardResponseObject.response_code !== "00") {
					console.warn("No approval found in response_text", NABancardResponseObject.response_text);
					this.showModalError("Payment Error", "Unsuccessful Response:\"" + NABancardResponseObject.response_text + "\"");
					return { ...defaultEmptyResponse, ...{ error: NABancardResponseObject.response_text } };
				}

				return {
					response,
					NABancardResponseObject,
					requestBody,
					error: "Unknown error"
				};
			} catch (e) {
				console.error("e", e);
				return defaultEmptyResponse;
			}
		},
		async DejavooPaymentProcessing (paymentType, amount) {
			this.dejavooTransactionCancelled = false;
			this.pendingDejavooPaymentType = paymentType;
			try {
				const subdomain = window.location.host.split('.')[0];
				const orderId = this.currentOrder.id || this.currentOrder.local_id;
				const timestamp = Math.floor(Date.now());
				const referenceId = `${subdomain}_${orderId}_${timestamp}`;
				const invoiceNumber = orderId;

        await this.$bvModal.show("processing-modal");

        let response;
        if (amount < 0) {
          // Handle refund
          response = await makeDejavooRefund(
            paymentType.url,
            amount,
            referenceId,
            invoiceNumber,
            paymentType.transaction_type
          );
        } else {
          // Handle sale - include surcharge in the amount if it exists
          const surchargeAmount = this.currentPaymentSurcharge ? this.currentPaymentSurcharge : 0;
          const totalAmount = amount + surchargeAmount;
// Check for cd_tip setting
					const isCdTipEnabled = isTerminalSettingEnabled(this.terminal, 'cd_tip');

					// For testing partial approval: if transaction_type is "TestPartial", it will trigger partial approval
					response = await makeDejavooPayment(paymentType.url, totalAmount, referenceId, invoiceNumber, paymentType.transaction_type);

					// Only after an approved payment, trigger CD Dejavoo tip flow if enabled
					if (response && this.customerDisplayEnabled && isCdTipEnabled) {
						try {
							const rewards = isTerminalSettingEnabled(this.terminal, 'rewards_module') ? 'true' : 'false'

							const { tpn, authkey } = parseDejavooConfig(paymentType.url);
							// Use PaymentType from Dejavoo response (e.g. "Credit"), fallback to transaction_type
							const dejavooPaymentType = response.PaymentType || paymentType.transaction_type;
							const cdPayload = {
								type: 'dejavoo-payment',
								token: localStorage.getItem('token'),
								local_id: this.currentOrder.local_id || this.currentOrder.id,
								order_id: this.currentOrder.id,
								rewards,
								data: {
									Amount: totalAmount,
									TipAmount: 0.00,
									PaymentType: dejavooPaymentType,
									ReferenceId: referenceId,
									Tpn: tpn,
									Authkey: authkey
								},
								order: this.optimizeOrderPayload ? this.optimizeOrderPayload(this.currentOrder) : this.currentOrder,
								cd_is_open: true,
								isSale: false
							};
							this.sendMessage(cdPayload);
						} catch (e) {
							console.error('Failed to send Dejavoo info to Customer Display', e)
						}
					}
				}

				if (this.dejavooTransactionCancelled) {
					throw new Error('Transaction cancelled by user');
				}

				// Check if this is a partial approval
        if (response && response.isPartialApproval) {
          // Get the approved amount from the response
          const approvedAmount = response.Amounts && response.Amounts.ApprovedAmount
            ? parseFloat(response.Amounts.ApprovedAmount)
            : 0;

          // Store partial approval data for later use
          this.partialApprovalData = {
            approvedAmount: approvedAmount,
            remainingBalance: this.currentOrderGrandTotalSum - approvedAmount,
            isVoiding: false,
            paymentType: paymentType,
            referenceId: referenceId,
            transactionType: paymentType.transaction_type,
            urlField: paymentType.url,
            lastPaymentObject: null,
            response: response
          };

          // Mark response as partial for the caller
          response.isPartialApproval = true;
        }

				// Response error check is now handled in makeDejavooPayment/makeDejavooRefund
				// We'll only get here if the payment/refund was approved
				return response;
			} catch (error) {
				this.cancelSurcharge();
				if (this.dejavooTransactionCancelled) {
					console.warn('Dejavoo transaction cancelled by user', error);
				} else {
					console.error('Error in Dejavoo payment processing:', error);
					this.showModalError("Payment Error", error.message || "Payment processing failed");
				}
				throw error;
			} finally {
				this.pendingDejavooPaymentType = null;
				this.$bvModal.hide("processing-modal");
			}
		},
		// User clicked Cancel on the processing modal while a Dejavoo card payment was in flight.
		// This does not stop the client's in-flight Sale/Refund fetch (DejavooPaymentProcessing's
		// dejavooTransactionCancelled check discards that response when it eventually settles) -
		// it just tells the terminal to stop, closes the modal, and restores the cart on the
		// terminal's screen (if cd_dejavoo is enabled) since the abort otherwise leaves it on the
		// payment prompt.
		async cancelDejavooTransaction() {
			const paymentType = this.pendingDejavooPaymentType;
			if (!paymentType) return;

			this.dejavooTransactionCancelled = true;
			this.$bvModal.hide("processing-modal");

			try {
				await makeDejavooAbortTransaction(paymentType.url);
			} catch (e) {
				console.warn('[Dejavoo] Failed to send AbortTransaction', e);
			}

			if (isTerminalSettingEnabled(this.terminal, 'cd_dejavoo')) {
				// The terminal is still busy finishing the abort/original sale request right
				// after AbortTransaction returns - give it a moment before pushing the cart.
				await new Promise((resolve) => setTimeout(resolve, 3000));
				try {
					const orderSource = `POS-${(this.terminal && (this.terminal.name || this.terminal.id)) || 'Unknown'}`;
					await sendDejavooCart(this.currentOrder, this.products, paymentType, orderSource);
				} catch (e) {
					console.warn('[Dejavoo] Failed to resend cart after abort', e);
				}
			}
		},
    async WindcavePaymentProcessing (paymentType, amount) {
      try {
        const localOrderId = this.currentOrder.local_id || this.currentOrder.localID || this.currentOrder.id;
        const orderId = this.currentOrder.id || this.currentOrder.local_id || this.currentOrder.localID;
        const txnRef = `${localOrderId}_${orderId}`;
        const surchargeAmount = this.currentPaymentSurcharge ? this.currentPaymentSurcharge : 0;
        const totalAmount = parseFloat((amount + surchargeAmount).toFixed(2));

        await this.$bvModal.show("processing-modal");
        return await makeWindcavePayment(
          paymentType.url,
          totalAmount,
          txnRef,
          this.terminal?.name || '',
          APP_VERSION
        );
      } catch (error) {
        console.error('Error in Windcave payment processing:', error);
        this.cancelSurcharge();
        this.showModalError("Payment Error", error.message || "Windcave payment processing failed");
        throw error;
      } finally {
        this.$bvModal.hide("processing-modal");
      }
    },
    pay: async function (paymentType, skipSurchargeCheck = false) {
      // 1. UI Lock
      if (this.isPaymentProcessing) return;
      this.isPaymentProcessing = true;

      try {
        if (this.hasUnavailable86dItems()) {
          this.showUnavailable86dCheckoutError();
          this.isPaymentProcessing = false;
          return;
        }

        const orderTotalSumBeforePayment = this.currentOrderGrandTotalSum;

        // --- Connectivity Check (Only blocking for Gift Cards) ---
        // For normal payments, we assume good faith or queue offline
        if(paymentType.behavior === PAYMENT_BEHAVIOR.GIFT_CARD) {
          const hasConnectivity = await this.checkInternetConnectivity().catch(() => false);
          if (!hasConnectivity){
            this.$bvModal.show('gift-card-not-available');
            this.isPaymentProcessing = false;
            return;
          }
        }

        // --- Kiosk Mode Early Return ---
        if (this.isKioskMode && !paymentType) {
          // Mutate the live store-backed order in place (proxy = single source).
          this.currentOrder.status = ORDER_STATUS.HOLD;
          this.currentOrder.hold_date = new Date().toISOString();
          this.currentOrder.description = "Pay at the register";
          this.isLoad = false;
          this.$bvModal.show("modal-kiosksalecompleted");
          this.closeKioskSaleCompletedModal();
          if (this.terminal.printer) {
            await this.printCheck(); // Printer might be local, so we await
          }
          this.isPaymentProcessing = false;
          return;
        }

        this.lastPaymentType = paymentType;

        // --- Total integrity self-heal ---
        // If the order carries line-style item discounts or a discount_total
        // that does not reconcile with its items (e.g. an online order that
        // slipped past ingress normalization), fix it silently and continue
        // the payment with the corrected totals. This must never stop the
        // sale - no modal, no extra tap.
        if (!this.refundOrderId && this.currentOrderSum >= 0) {
          const normalizedOrder = normalizeOrderDiscounts(this.currentOrder);
          const discountsWereLineStyle = normalizedOrder !== this.currentOrder;
          if (discountsWereLineStyle) {
            this.currentOrder.items = normalizedOrder.items;
          }
          if (discountsWereLineStyle || getOrderDiscountMismatch(this.currentOrder)) {
            const previousTotal = this.currentOrderGrandTotalSum;
            this.countSubtotal();
            this.$store.dispatch("orders/saveOrder", this.currentOrder);
            // Refresh the prefilled tendered amount so the charge uses the
            // corrected total; never override an amount the cashier typed.
            if (this.isAmountPreFilled) {
              this.amountTenderedString = Math.round(this.currentOrderGrandTotalSum * 100).toString();
            }
            const message =
              `[Checkout] Order totals reconciled before payment: ` +
              `${previousTotal.toFixed(2)} -> ${this.currentOrderGrandTotalSum.toFixed(2)} ` +
              `(order ${this.currentOrder.id || this.currentOrder.local_id})`;
            console.warn(message);
          }
        }

        // --- Refund / GiftCard / Surcharge Checks ---
        const isZeroTotal = Math.abs(this.currentOrderGrandTotalSum) < 0.001;
        const isCash = paymentType.behavior === PAYMENT_BEHAVIOR.ALLOW_CHANGE;

        if (
            !this.isKioskMode &&
            isCash &&
            (
                (this.amountTendered < 0.01 && !this.refundOrderId && !isZeroTotal) ||
                (this.amountTendered < 0.01 && !this.refundTenderedAmount && !isZeroTotal)
            )
        ) {
          this.refundTenderedAmount = this.refundOrderId ? true : false
          if (paymentType.behavior === PAYMENT_BEHAVIOR.GIFT_CARD) {
            this.amountTenderedString = Math.round(this.currentOrderGrandTotalSum * 100).toString();
            this.isAmountPreFilled = true;
            this.$bvModal.show('gift-voucher-modal');
            this.toggleGiftCardPaymentInitiater();
            this.isPaymentProcessing = false;
            return this.amountTenderedString;
          } else {
            this.isPaymentProcessing = false;
            this.isAmountPreFilled = true;
            return this.amountTenderedString = Math.round(this.currentOrderGrandTotalSum * 100).toString();
          }
        }

        if (this.amountTendered < 0.01 && !isZeroTotal && !this.refundOrderId) {
          this.amountTenderedString = Math.round(this.currentOrderGrandTotalSum * 100).toString();
          this.isAmountPreFilled = false;
        }

        if (!this.isGiftCardPaymentInitiated && paymentType.behavior === PAYMENT_BEHAVIOR.GIFT_CARD) {
          this.$bvModal.show('gift-voucher-modal');
          this.toggleGiftCardPaymentInitiater();
          this.isPaymentProcessing = false;
          return;
        }

        if(paymentType.surcharge && paymentType?.surcharge > 0 && !skipSurchargeCheck && (!this.refundTenderedAmount || this.currentOrderGrandTotalSum > 0)) {
          if (this.showCashCardPrice) {
            this.surchargeValue = paymentType.surcharge;
            this.currentPaymentSurcharge = parseFloat(
              this.surchargeCharged(this.amountTendered, this.surchargeValue).toFixed(2)
            );
            this.setSurcharge(true);
          } else {
            this.showSurchargeModal(paymentType.surcharge);
            this.isPaymentProcessing = false;
            return;
          }
        }

        // --- Main Payment Logic ---
        this.behavior = paymentType.behavior;
        // Phase 4 payment strategy layer: pick the processor for this behavior and
        // collect a normalized result. Non-integration behaviors (cash, gift card,
        // direct charge) keep the default "no data" result. Device I/O and side
        // effects (modals, store writes, the payment lock) stay here by design.
        const processor = getPaymentProcessor(this.behavior);
        let paymentResult = processor.normalize();
        let DejavooResponseObject = {};

        // FIX: Explicit rounding to prevent floating point issues (49.480000004)
        let amount = parseFloat(Number(this.amountTendered).toFixed(2));

        if (
            (this.behavior === PAYMENT_BEHAVIOR.DIRECT_CHARGE
                || this.behavior === PAYMENT_BEHAVIOR.NABANCARD_INTEGRATION
                || this.behavior === PAYMENT_BEHAVIOR.DEJAVOO_INTEGRATION
                || this.behavior === PAYMENT_BEHAVIOR.WINDCAVE_INTEGRATION)
            && this.amountTendered >= this.currentOrderGrandTotalSum
        ) {
          amount = parseFloat(Number(this.currentOrderGrandTotalSum).toFixed(2));
          if(this.behavior === PAYMENT_BEHAVIOR.DIRECT_CHARGE
              && this.currentPaymentSurcharge && this.currentPaymentSurcharge > 0) {
            amount = parseFloat((this.currentOrderGrandTotalSum + parseFloat(this.currentPaymentSurcharge)).toFixed(2));
          }
        }
        let tips = this.currentOrder.tips_total || 0;

        // --- Integrations Processing ---
        if (this.behavior === PAYMENT_BEHAVIOR.NABANCARD_INTEGRATION) {
          const NABancardResponse = await this.NABancardPaymentProcessing(paymentType, amount);
          paymentResult = processor.normalize(NABancardResponse);
          if (paymentResult.tips != null) {
            tips = paymentResult.tips;
          }
          if (!paymentResult.approved){
            this.cancelSurcharge();
            this.isPaymentProcessing = false;
            return this.showModalError("Payment Error", `Unsuccessful. Reason: ${paymentResult.error ? paymentResult.error : "No info"}`);
          }
        } else if (this.behavior === PAYMENT_BEHAVIOR.DEJAVOO_INTEGRATION) {
          // ... (DEJAVOO LOGIC REMAIN UNCHANGED - It's correct from previous fix) ...
          const DejavooResponse = await this.DejavooPaymentProcessing(paymentType, amount);

          paymentResult = processor.normalize(DejavooResponse);

          if (DejavooResponse && DejavooResponse.CardData) {
            DejavooResponseObject.card_lastfour = DejavooResponse.CardData.Last4 || '';
          } else if (DejavooResponse && DejavooResponse.ExtendedDataByApplication) {
            const firstApp = Object.values(DejavooResponse.ExtendedDataByApplication)[0];
            DejavooResponseObject.card_lastfour = firstApp?.AcntLast4 || '';
          }

          if (DejavooResponse && DejavooResponse.Amounts && DejavooResponse.Amounts.TipAmount) {
            const tipAmount = parseFloat(DejavooResponse.Amounts.TipAmount);
            if (tipAmount > 0) {
              this.lastDejavooTip = tipAmount;
              this.currentOrder.tips_total = (this.currentOrder.tips_total || 0) + tipAmount;
              tips = tipAmount;
            }
          }

          // Terminal-applied surcharge when POS payment type has no surcharge configured
          if (
            (!paymentType.surcharge || paymentType.surcharge <= 0)
            && (!this.currentPaymentSurcharge || this.currentPaymentSurcharge <= 0)
          ) {
            const terminalFee = getDejavooFeeAmount(DejavooResponse);
            if (terminalFee > 0) {
              this.currentPaymentSurcharge = terminalFee;
            }
          }

          if (DejavooResponse && DejavooResponse.isPartialApproval) {
            // ... (PARTIAL APPROVAL LOGIC UNCHANGED) ...
            if (DejavooResponse && DejavooResponse.CardData) {
              DejavooResponseObject.card_lastfour = DejavooResponse.CardData.Last4 || '';
              DejavooResponseObject.card_type = DejavooResponse.CardData.CardType || '';
              DejavooResponseObject.entry_type = DejavooResponse.CardData.EntryType || '';
              DejavooResponseObject.card_first4 = DejavooResponse.CardData.First4 || '';
              DejavooResponseObject.card_bin = DejavooResponse.CardData.BIN || '';
              DejavooResponseObject.card_expiration = DejavooResponse.CardData.ExpirationDate || '';
              DejavooResponseObject.cardholder_name = DejavooResponse.CardData.Name || '';
            }
            if (DejavooResponse) {
              DejavooResponseObject.auth_code = DejavooResponse.AuthCode || '';
              DejavooResponseObject.transaction_type = DejavooResponse.TransactionType || '';
              DejavooResponseObject.reference_id = DejavooResponse.ReferenceId || '';
              DejavooResponseObject.approval_message = DejavooResponse.GeneralResponse ?
                  (DejavooResponse.GeneralResponse.DetailedMessage || DejavooResponse.GeneralResponse.Message || '') : '';
              if (DejavooResponse.Amounts && DejavooResponse.Amounts.TipAmount) {
                tips = parseFloat(DejavooResponse.Amounts.TipAmount);
                this.currentOrder.tips_total = tips;
                this.lastDejavooTip = tips;
              }
            }

            const currentShift = this.$store.getters.shift;
            const approvedAmount = this.partialApprovalData.approvedAmount;

            const partialPaymentObject = {
              order: this.currentOrder.id ? this.currentOrder.id : this.currentOrder.local_id,
              employee: this.employee ? this.employee.id : null,
              amount: parseFloat(approvedAmount.toFixed(2)), // Fix floating point
              amount_paid: parseFloat(approvedAmount.toFixed(2)), // Fix floating point
              tips: tips,
              change_amount: 0,
              payment_type: paymentType ? paymentType.name : null,
              payment_date: new Date().toISOString(),
              related_terminal: this.terminal.id,
              transaction_type: TRANSACTION_TYPE.SALE,
              processor_response: serializeDejavooProcessorResponse(DejavooResponse),
              card_lastfour: DejavooResponseObject.card_lastfour || null,
              local_id: `${this.terminal.id}_${this.currentOrder.payments.length + 1}_${Date.now()}`,
              shift: currentShift.id,
              gift_card: this.activeGiftCard ? this.activeGiftCard.id : null
            };

            if (this.currentOrder.payments) {
              this.currentOrder.payments.push(partialPaymentObject);
            } else {
              this.currentOrder.payments = [partialPaymentObject];
            }
            this.partialApprovalData.lastPaymentObject = partialPaymentObject;

            this.getOrderSync().flush({ queue: true, trigger: "dejavoo_partial_payment" }).catch(() => {});
            this.$store.dispatch("sync").catch(e => console.warn("Background sync failed", e));

            this.amountTenderedString = Math.round(this.currentOrderGrandTotalSum * 100).toString();
            this.isAmountPreFilled = true;
            this.$bvModal.show("dejavoo-partial-approval-modal");
            this.isPaymentProcessing = false;
            return;
          }
        } else if (this.behavior === PAYMENT_BEHAVIOR.WINDCAVE_INTEGRATION) {
          const windcaveResponse = await this.WindcavePaymentProcessing(paymentType, amount);
          paymentResult = processor.normalize(windcaveResponse);
        }

        // --- Create Payment Object ---
        const currentShift = this.$store.getters.shift;
        const balance = parseFloat((orderTotalSumBeforePayment - this.amountTendered).toFixed(2));
        this.currentOrder.balance_remaining = (balance < 0 && !this.refundOrderId) ? 0 : parseFloat(balance.toFixed(2));
        const changeAmount = this.behavior === PAYMENT_BEHAVIOR.ALLOW_CHANGE ? this.amountChange : 0;

        // FIX: Ensure clean numbers for payment object
        const finalAmountPaid = amount > orderTotalSumBeforePayment ? orderTotalSumBeforePayment : amount;

        const paymentObject = {
          order: this.currentOrder.id ? this.currentOrder.id : this.currentOrder.local_id,
          employee: this.employee ? this.employee.id : null,
          amount: parseFloat(amount.toFixed(2)),
          amount_paid: parseFloat(finalAmountPaid.toFixed(2)),
          tips: tips,
          change_amount: changeAmount,
          payment_type: paymentType ? paymentType.name : null,
          payment_date: new Date().toISOString(),
          related_terminal: this.terminal.id,
          transaction_type: this.currentOrderSum < 0.01 ? TRANSACTION_TYPE.RETURN : TRANSACTION_TYPE.SALE ,
          processor_response: paymentResult.processorResponse,
          card_lastfour: paymentResult.cardLastFour,
          local_id: `${this.terminal.id}_${this.currentOrder.payments.length + 1}_${Date.now()}`,
          shift: currentShift.id,
          gift_card: this.activeGiftCard ? this.activeGiftCard.id : null
        };

        if (this.currentOrder.payments) {
          this.currentOrder.payments.push(paymentObject);
        } else {
          this.currentOrder.payments = [paymentObject];
        }

        if (this.currentPaymentSurcharge && this.currentPaymentSurcharge > 0) {
          const previousSurchargeTotal = parseFloat(this.currentOrder.surcharge_value || 0);
          const currentSurcharge = parseFloat(this.currentPaymentSurcharge);
          this.currentOrder.surcharge_value = parseFloat((previousSurchargeTotal + currentSurcharge).toFixed(2));
          this.currentPaymentSurcharge = 0;
        }

        // --- Shift Update (Fire and Forget / Safe) ---
        if (!this.isKioskMode) {
          this.savePaymentToShift({ name: paymentType.name, amount: paymentObject.amount_paid })
              .catch(err => console.warn("Background Shift update failed (offline)", err));
        }

        // --- Finalize Order ---
        const isOrderFullyPaid = this.amountTendered >= orderTotalSumBeforePayment;

        if (isOrderFullyPaid) {
          if (typeof this.refundOrderId === 'string') {
            if (this.refundOrderId.includes("_")) {
              this.currentOrder.reference_order = null
            } else {
              this.currentOrder.reference_order = this.refundOrderId
            }
          }
          this.currentOrder.status = this.currentOrderSum < 0.00 ? ORDER_STATUS.REFUNDED : ORDER_STATUS.COMPLETED
          this.currentOrder.close_date = new Date().toISOString();
          if (!this.isKioskMode) {
            this.currentOrder.related_terminal = this.terminal.id;
            this.currentOrder.shift = currentShift.id;
            this.currentOrder.emp_close = this.employee ? this.employee.id : null;
          }
        }

        // 1. SAVE LOCALLY (Instant)
        this.$store.dispatch("orders/saveOrder", this.currentOrder);

        // 2a. For fully-paid orders: persist the final snapshot to the outbox immediately.
        //     This is the authoritative closed-order queue intent; navigation/watchers
        //     can fire later, but they will coalesce into this same outbox row.
        if (isOrderFullyPaid) {
          const completedSnapshot = JSON.parse(JSON.stringify(this.currentOrder));
          await this.$store.dispatch("orders/enqueueOrderSync", {
            order: completedSnapshot,
            trigger: "checkout_completed"
          });
          this.$store.dispatch("orders/drainOrderSyncOutbox")
            .catch(e => console.warn("Order outbox drain failed:", e));
        }

        // 2b. Background batch sync for any other dirty orders (shifts, partial payments, etc.)
        this.$store.dispatch("sync").catch(e => console.warn("Background sync failed (offline)", e));

        if(paymentType.behavior === PAYMENT_BEHAVIOR.GIFT_CARD)
          this.toggleGiftCardPaymentInitiater()

        // 3. Customer Display (Fire and Forget)
        try {
          if (!isOrderFullyPaid || this.isKioskMode) {
            this.sendOrderToChannel(this.currentOrder);
          }
        } catch (cdError) {
          console.warn("Customer Display update failed, ignoring...", cdError);
        }

        // --- Post-Processing & Success Modal (IMMEDIATE) ---
        try {
          if (isOrderFullyPaid && !this.isKioskMode) {
            // We still await printing because that's a local hardware action
            if (isTerminalSettingEnabled(this.terminal, "autosend_kitchen")) {
              this.printKitchenCheck().catch(e => console.warn("Kitchen print failed", e));
            }

            const surchargeValue = parseFloat(this.currentOrder.surcharge_value || 0);
            const newSale = {
              isSale: true,
              sale: {
                isCash: this.behavior === PAYMENT_BEHAVIOR.ALLOW_CHANGE,
                transactionAmount: parseFloat((this.amountTendered + surchargeValue).toFixed(2)),
                changeTenderAmount: this.changeAmountLast
              }
            }
            try {
              this.sendOrderToChannel(newSale)
            } catch(e) {
              // Customer Display update is non-critical
            }

            this.setRefundGiftCardIds([])
            if (this.$store.getters["giftVoucher/selectedGiftCards"].length > 0) {
              this.creditSelectedGiftCards().catch(e => console.warn(e));
            }

            // Show Success Modal Guaranteed
            this.$bvModal.show("modal-salecompleted");
          } else if (isOrderFullyPaid && this.isKioskMode) {
            if (this.$store.getters["giftVoucher/selectedGiftCards"].length > 0) {
              this.creditSelectedGiftCards().catch(e => console.warn(e));
            }
            this.$bvModal.show("modal-kiosksalecompleted");
            this.closeKioskSaleCompletedModal()
            if (this.terminal.printer) {
              this.printCheck().catch(e => console.warn(e));
              this.printKitchenCheck().catch(e => console.warn(e));
            }
          }
        } catch (postError) {
          console.error("Post-processing error:", postError);
          // Even if post-processing fails, show success if paid
          if (isOrderFullyPaid && !this.isKioskMode) {
            this.$bvModal.show("modal-salecompleted");
          }
        }

        if (parseFloat(parseFloat(this.currentOrderGrandTotalSum).toFixed(2)) <= 0) {
          try {
            if (this.behavior === PAYMENT_BEHAVIOR.ALLOW_CHANGE) {
              openDrawer();
            }
          } catch (e) {
            console.error(e);
          }
        }

        this.resetNum();
      } catch (e) {
        console.error("Payment processing error:", e);
      } finally {
        // Unlock UI quickly
        setTimeout(() => {
          this.isPaymentProcessing = false;
        }, 200);
      }
    },
    newSale: async function () {
      // Reset Dejavoo tip for new sale
      this.lastDejavooTip = 0;

      this.$bvModal.hide("modal-salecompleted");
      if (typeof this.sendBlankPayloadToCustomerDisplay === "function") {
        await this.sendBlankPayloadToCustomerDisplay();
      }

      const savedOrder = this.$store.getters["orders/getOrderByIdOrLocalId"]((this.currentOrder.id || this.currentOrder.local_id));
			if (!savedOrder || savedOrder.status !== 3) {
				console.warn("Prev order is not closed..");
        if (!this.refundOrderId) {
          if (savedOrder) savedOrder.status = 3; // null guard — savedOrder can be null if the order was never persisted
        } else {
          this.setRefundOrderId(null)
          this.refundTenderedAmount = false
        }
      }

			// Online orders should return to the Online Orders view once payment completes
			if (this.currentOrder && this.currentOrder.type === 1) {
				return await this.$router.push({ name: "OnlineOrder" });
			}

			if (!this.currentOrder.table && this.terminalMode === "QUICK_SERVICE") {
        // await this.emptyOrder()
        return await this.$router.push({
					name: "Order",
					params: {
						tableID: null,
						id: "new"
					}
				});
			} else if (!this.currentOrder.table) {
				return await router.push({ name: "Tables" });
			}
			this.table = this.$store.getters.getTableWithOrders(this.currentOrder.table);
			if (this.table && this.table.tableOrders && this.table.tableOrders.length === 0) {
				await router.push({ name: "Tables" });
			} else if (this.table && this.table.tableOrders) {
				await router.push({ name: "TableOrders", params: { id: this.currentOrder.table } });
			} else if (this.isKioskMode) {
				await router.push({ name: "KioskHomeV2" });
			}
		},
		showModalError (title, info) {
			this.error.title = title;
			this.error.info = info;
			this.isPaymentProcessing = false;
			this.$bvModal.show("modal-error-checkout");
		},
		displayPaymentDetails: function () {
			return this.isDisplayPaymentDetails = !this.isDisplayPaymentDetails;
    },
    async holdOrder(payload) {
      if (this.$route.params.id === "new" || this.currentOrder.id === 0) return true;
      // Mutate the live store-backed order in place (proxy = single source).
      this.currentOrder.status = ORDER_STATUS.HOLD;
      this.currentOrder.hold_date = new Date().toISOString();
      this.currentOrder.description = payload.description;
      this.currentOrder.locked_by = null;

      // Save the order to the store so the status change is reflected
      await this.$store.dispatch("orders/saveOrder", this.currentOrder);

      if (typeof this.sendBlankPayloadToCustomerDisplay === 'function') {
        this.sendBlankPayloadToCustomerDisplay();
      }

      // await this.sync();

      // If in Quick Service mode, always redirect to new order regardless of table
      if (this.terminalMode === "QUICK_SERVICE") {
        await router.push({
          name: "NewOrderRedirect",
          params: {}
        }, () => {
        });
        return null;
      }

      // For Table Service mode, handle table navigation
      if (!this.currentOrder.table) {
        await router.push({
          name: "NewOrderRedirect",
          params: {}
        }, () => {
        });
        return null;
      }

      // Now check if there are any remaining open orders on this table
      this.table = this.$store.getters.getTableWithOrders(this.currentOrder.table);
      this.table.tableOrders.length === 0
        ? await router.push({ name: "Tables" })
        : await router.push({ name: "TableOrders", params: { id: this.currentOrder.table } }, () => {
        });
    },
    closeKioskSaleCompletedModal(){
      // automatically close the kiosk sales completed modal after 10 sec
      setTimeout(()=>{
        const self = this
        self.$bvModal.hide("modal-kiosksalecompleted")
        self.$router.push({path:'/'})
      },10000)
    },
    showSurchargeModal(surchargeValue = 0){
      this.surchargeValue = surchargeValue
      // const existingSurcharge = this.currentOrder.surcharge_value || 0
      const newSurcharge = parseFloat((this.surchargeCharged(this.amountTendered,this.surchargeValue)).toFixed(2))
      this.currentPaymentSurcharge = newSurcharge
      this.sendOrderToChannel(this.currentOrder)

      this.$bvModal.hide('processing-modal')
      this.$bvModal.show('surcharge-modal')

    },
    addSurcharge(){
      this.setSurcharge(true)
      this.$bvModal.hide('surcharge-modal')
      this.pay(this.lastPaymentType, true)
    },
    cancelSurcharge(){
      // Revert the surcharge addition if cancelled
      this.currentPaymentSurcharge = 0

      this.$bvModal.hide('surcharge-modal')
      this.$bvModal.hide('processing-modal')
      this.sendOrderToChannel(this.currentOrder)
    },
    handleContinueToPay() {
      // Close the partial approval modal
      this.$bvModal.hide("dejavoo-partial-approval-modal");

      // Reset the partial approval data
      this.partialApprovalData = {
        approvedAmount: 0,
        remainingBalance: 0,
        isVoiding: false,
        paymentType: null,
        referenceId: null,
        transactionType: null,
        urlField: null,
        lastPaymentObject: null
      };

      // User can now make another payment for the remaining balance
      // The order should already have the partial payment recorded
    },
    async handleVoidPartialPayment() {
      try {
        // Set voiding state
        this.partialApprovalData.isVoiding = true;

        const lastPay = this.partialApprovalData.lastPaymentObject;
        let voidParams = lastPay && lastPay.processor_response
          ? getDejavooVoidParamsFromSaleResponse(lastPay.processor_response)
          : null;
        if (!voidParams && this.partialApprovalData.response) {
          voidParams = getDejavooVoidParamsFromSaleResponse(this.partialApprovalData.response);
        }
        if (!voidParams) {
          voidParams = {
            referenceId: this.partialApprovalData.referenceId,
            paymentType: this.partialApprovalData.paymentType?.transaction_type || 'Credit',
            amount: this.partialApprovalData.approvedAmount
          };
        }
        if (!voidParams.referenceId || !voidParams.paymentType || !voidParams.amount) {
          throw new Error('Cannot void: missing ReferenceId, PaymentType, or amount on this payment.');
        }

        const voidResponse = await makeDejavooVoid(this.partialApprovalData.urlField, {
          amount: voidParams.amount,
          referenceId: voidParams.referenceId,
          paymentType: voidParams.paymentType,
          integrationTransactionType: this.partialApprovalData.paymentType?.transaction_type
        });

        // New negative payment entry reverses the original (keep audit trail)
        if (this.partialApprovalData.lastPaymentObject) {
          const originalPayment = this.partialApprovalData.lastPaymentObject;
          const currentShift = this.$store.getters.shift;

          const voidedAmount = voidParams.amount;
          const reversalAmount = -Math.abs(voidedAmount);

          // Create the reversal payment entry
          const reversalPaymentObject = {
            order: this.currentOrder.id ? this.currentOrder.id : this.currentOrder.local_id,
            employee: this.employee ? this.employee.id : null,
            amount: reversalAmount,
            amount_paid: reversalAmount,
            tips: 0,
            change_amount: 0,
            payment_type: originalPayment.payment_type,
            payment_date: new Date().toISOString(),
            related_terminal: this.terminal.id,
            transaction_type: TRANSACTION_TYPE.RETURN,
            processor_response: serializeDejavooProcessorResponse(voidResponse),
            card_lastfour: originalPayment.card_lastfour,
            local_id: `${this.terminal.id}_${this.currentOrder.payments.length + 1}_${Date.now()}`,
            shift: currentShift.id,
            gift_card: null
          };

          // Add the reversal payment to the order
          if (this.currentOrder.payments) {
            this.currentOrder.payments.push(reversalPaymentObject);
          } else {
            this.currentOrder.payments = [reversalPaymentObject];
          }

          // Save payment to shift as refund
          if (!this.isKioskMode) {
            try {
              await this.savePaymentToShift(
                { name: originalPayment.payment_type, amount: reversalPaymentObject.amount_paid },
                "refund"
              );
            } catch (shiftError) {
              console.warn("Shift update failed (offline), proceeding...", shiftError);
            }
          }
        }

        this.getOrderSync().flush({ queue: true, trigger: "dejavoo_partial_close" }).catch(() => {});
        this.$store.dispatch("sync").catch(syncError =>
          console.warn("Sync failed (likely offline), proceeding to close sale locally.", syncError)
        );

        // Close the modal
        this.$bvModal.hide("dejavoo-partial-approval-modal");

        // Reset partial approval data
        this.partialApprovalData = {
          approvedAmount: 0,
          remainingBalance: 0,
          isVoiding: false,
          paymentType: null,
          referenceId: null,
          transactionType: null,
          urlField: null,
          lastPaymentObject: null
        };

        // Show success message
        this.showModalError("Transaction Voided", "The partial payment has been voided successfully.");
      } catch (error) {
        console.error('Error voiding partial payment:', error);
        this.partialApprovalData.isVoiding = false;
        this.showModalError("Void Error", error.message || "Failed to void the partial payment. Please try again.");
      }
    },
    creditSelectedGiftCards(){
      this.updateGiftCardCredits()
    },
    async payFromGiftCard(giftCardPayment){
      giftCardPayment.order = this.currentOrder.id
      giftCardPayment.local_id = this.currentOrder.local_id
      if(await this.recordGiftCardPayments(giftCardPayment)){
        if(this.amountTendered !== giftCardPayment.amount_paid){
          this.amountTenderedString = Math.round(giftCardPayment.amount_paid * 100).toString()
          this.isAmountPreFilled = false;
        }
        this.pay(this.lastPaymentType)
      }
    },
    getItemDisplayName(item) {
      // Shared, pure resolver (Step 2); honors the kitchen_name_pos setting.
      return resolveItemDisplayName(item, this.terminal, this.products);
    }

	}
};
</script>
<style lang="scss">
.calc-control {
	overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.calc-control::-webkit-scrollbar {
	-webkit-appearance: none;
}

.calc-control::-webkit-scrollbar:vertical {
	width: 11px;
}

.calc-control::-webkit-scrollbar:horizontal {
	height: 11px;
}

.calc-control::-webkit-scrollbar-thumb {
	border-radius: 8px;
	border: 2px solid white; /* should match background, can't be transparent */
	background-color: rgba(0, 0, 0, .5);
}

.qash {
	margin-bottom: 30px;

	.btn {
		height: 50px;
		width: 140px;
	}
}

.btn-disabled {
	cursor: not-allowed;
	pointer-events: none;
	opacity: 0.4;
}

.sent_to_kitchen .align-items-center {
	font-style: italic;
	color: #888888;
}

.spiner-overbutton {
	position: absolute;
	top: 19px;
	z-index: 10;
	margin-left: auto;
	margin-right: auto;
	left: 0;
	right: 0;
	text-align: center;
}

.points-redeemed-item{
  border: 1px solid rgba(214, 160, 16, 0.35);
  box-shadow: 0 2px 10px rgba(214, 160, 16, 0.12);
}

.points-redeemed-head{
  background: linear-gradient(90deg, rgba(255, 236, 179, 0.55), rgba(255, 215, 0, 0.28));
}

.badge-rewards{
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #6b4d00;
  background: linear-gradient(120deg, #fff3b0, #ffd54a, #fff3b0);
  background-size: 200% 100%;
  border: 1px solid rgba(214, 160, 16, 0.55);
  box-shadow: 0 1px 6px rgba(214, 160, 16, 0.18);
  padding: 0.22rem 0.45rem;
  border-radius: 0.35rem;
  font-size: 0.72em;
  text-transform: uppercase;
  animation: rewardsShimmer 1.8s ease-in-out infinite;
}

@keyframes rewardsShimmer {
  0% { background-position: 0% 0%; }
  50% { background-position: 100% 0%; }
  100% { background-position: 0% 0%; }
}
</style>
